import React, { ReactNode } from "react";

interface CoSuspenseProps {
  children: ReactNode;
  isLoading: boolean;
  loadingComponent: React.ReactNode;
}

export function CoSuspense({ children, loadingComponent, isLoading }: CoSuspenseProps) {
  if (isLoading) return <>{loadingComponent}</>;
  return <>{children}</>;
}
